// Contrato de Horarios Claros (docs/HORARIOS_CLAROS_BRIEF.md). 0 = Lunes en todos los días.

export type Problema = "nombreDistinto" | "fueraDeHorario" | "muyLarga" | "aulaChocada" | "maestraChocada" | "sinAlumnas" | "fechaRara" | "sinSesiones";
export type EstadoHorario = "enCurso" | "porEmpezar" | "terminado" | "fusionado" | "nuncaComenzo";
export type TabKey = "enCurso" | "porEmpezar" | "terminados" | "todos" | "revisar";

export interface SesionHorario { dia: number; inicio: string; fin: string }

/** Choque de aula o maestra (mismo contrato que _validar). */
export interface ConflictoHorario {
	tipo: "aula" | "maestra"; scheduleId: number; curso: string; modulo: string; hora: string; aula: string; maestra: string; alumnas: number; fin: string;
}

interface ClaseFechada { fecha: string; inicio: string; fin: string }
/** Qué Va a Pasar al cambiar la hora (GET _cambiarHora; el PUT devuelve lo mismo con aplicado). */
export interface PlanCambioHora {
	horario: {
		id: number; nombre: string; nombreNuevo: string; hora: string; horaNueva: string;
		sesiones: SesionHorario[]; sesionesNuevas: SesionHorario[]; inicio: string; fin: string; finNuevo: string;
	};
	errores: string[];
	diasDistintos: boolean;
	conflictos: ConflictoHorario[];
	mensajeChoque: string | null;
	movidas: { claseId: number; numero: number; de: ClaseFechada; a: ClaseFechada }[];
	seQuedan: { claseId: number; numero: number; fecha: string; inicio: string; fin: string; codigo: string; motivo: string }[];
	resumen: { clases: number; movidas: number; seQuedan: number; pasadas: number; anuladas: number; sinCambio: number };
	puedeConfirmar: boolean;
	puedeForzar: boolean;
	aplicado?: boolean;
}

export interface FilaHorario {
	id: number;
	code: string;
	cursoId: number;
	curso: string;
	moduloId: number;
	modulo: string;
	nombre: string;
	hora: string;
	sesiones: SesionHorario[];
	aulaId: number | null;
	aula: string | null;
	edificio: string | null;
	maestraId: number | null;
	maestra: string | null;
	periodoId: number | null;
	periodo: string | null;
	inicio: string;
	fin: string;
	alumnas: number;
	cupo: number | null;
	statusId: number;
	estado: EstadoHorario;
	kitsPendientes: number;
	problemas: Problema[];
}

export interface HorariosLista {
	rows: FilaHorario[];
	total: number;
	counts: { enCurso: number; porEmpezar: number; terminados: number; revisar: number };
}

export interface OpcionesHorarios {
	cursos: { id: number; name: string }[];
	modulos: { id: number; name: string; cursoId: number }[];
	maestras: { id: number; name: string }[];
	aulas: { id: number; name: string; edificio: string; edificioId: number }[];
	periodos: { id: number; name: string }[];
}

export interface FichaHorario extends FilaHorario {
	precios: Record<string, number | string | null>;
	creadoPor?: string | null;
	creadoEl?: string | null;
	ultimaLista?: string | null;
	asistencia?: number | null;
	/** Solo con «nombreDistinto»: la hora que dice el nombre (null si no se puede leer) y el nombre que saldría de las clases. */
	sesionesDelNombre?: SesionHorario[] | null;
	horaDelNombre?: string | null;
	nombreDesdeSesiones?: string | null;
}

export interface BloqueOcupacion {
	scheduleId: number;
	curso: string;
	modulo: string;
	inicio: string;
	fin: string;
	alumnas: number;
	maestra: string | null;
	estado: string;
	choque: boolean;
}

export interface OcupacionAulas {
	aulas: { id: number; nombre: string; edificio: string; bloques: BloqueOcupacion[] }[];
}

export interface Filtros {
	cursos: number[];
	modulos: number[];
	maestras: number[];
	aulas: number[];
	dias: number[];
	periodos: number[];
	kitPendiente: boolean;
}

export const FILTROS_VACIOS: Filtros = { cursos: [], modulos: [], maestras: [], aulas: [], dias: [], periodos: [], kitPendiente: false };

export const hayFiltros = (f: Filtros): boolean =>
	f.cursos.length > 0 || f.modulos.length > 0 || f.maestras.length > 0 || f.aulas.length > 0 || f.dias.length > 0 || f.periodos.length > 0 || f.kitPendiente;

/** Lo que el formulario necesita para abrirse desde un hueco de la ocupación o desde un enlace. */
export interface FormularioPedido {
	horarioId?: number | null;
	nivelId?: number | null;
	aulaId?: number | null;
	weekDay?: number | null;
	inicio?: string | null;
}
